// import DatePickerLocale from 'rmc-date-picker/lib/locale/en_US';

export default {
  okText: 'Ok',
  dismissText: 'Annuller',
  extra: 'VÃ¦lg venligst',
  // DatePickerLocale,
  year: '',
  month: '',
  day: '',
  hour: '',
  minute: '',
  am: 'AM',
  pm: 'PM'
};
